<template>
  <input
    ref="input"
    v-model="model"
    type="tel"
    class="demo__tel-input"
    autocomplete="tel"
    v-bind="inputProps"
    @countrychange="updateCountry"
    @input="updateValue"
    @blur="updateBlur"
  />
</template>

<script>
import intlTelInput from "intl-tel-input/intlTelInputWithUtils";

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    inputProps: {
      type: Object,
      default: () => ({}),
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      model: this.value,
      instance: null,
      wasPreviouslyValid: false,
    };
  },
  watch: {
    value(newValue) {
      this.model = newValue;
      if (this.instance) {
        this.instance.setNumber(newValue);
      }
    },
    disabled(newValue) {
      if (this.instance) {
        this.instance.setDisabled(newValue);
      }
    },
  },
  mounted() {
    if (this.$refs.input) {
      const notRuOptions =
        process.env.VUE_APP_INSTALLATION !== "ru"
          ? {
              preferredCountries: [process.env.VUE_APP_INSTALLATION],
              excludeCountries: ["ru"],
            }
          : {};

      this.instance = intlTelInput(this.$refs.input, {
        initialCountry: process.env.VUE_APP_DEFAULT_PHONE_CODE,
        ...notRuOptions,
        ...this.options,
      });
      if (this.value) {
        this.instance.setNumber(this.value);
      }

      if (this.disabled) {
        this.instance.setDisabled(this.disabled);
      }
    }
  },
  beforeDestroy() {
    if (this.instance) {
      this.instance.destroy();
    }
  },
  methods: {
    handleBlur() {
      this.updateValidity();
    },
    isValid() {
      if (this.instance) {
        return this.instance.isValidNumber();
      }
      return null;
    },
    updateValidity() {
      const isCurrentlyValid = this.isValid();

      if (this.wasPreviouslyValid !== isCurrentlyValid) {
        this.wasPreviouslyValid = isCurrentlyValid;

        this.$emit("changeValidity", !!isCurrentlyValid);
        this.$emit(
          "changeErrorCode",
          isCurrentlyValid ? null : this.instance.getValidationError()
        );
      }
    },
    updateBlur() {
      this.$emit("blur", this.instance?.getNumber() ?? "");
      this.updateValidity();
    },
    updateValue() {
      this.$emit("changeNumber", this.instance?.getNumber() ?? "");
      this.updateValidity();
    },
    updateCountry() {
      this.$emit(
        "changeCountry",
        this.instance?.getSelectedCountryData().iso2 ?? ""
      );
    },
  },
};
</script>
